// src/styles/styles.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;
    background: ${props => props.theme?.palette?.mode === 'dark'
      ? (props.theme?.custom?.gradients?.appBackgroundDark || props.theme?.palette?.background?.default || '#0B0B12')
      : (props.theme?.custom?.gradients?.appBackgroundLight || props.theme?.palette?.background?.default || '#f5f5f5')};
    color: ${props => props.theme?.palette?.mode === 'dark'
      ? '#E0E0E0'
      : props.theme?.palette?.text?.primary || '#111'};
    transition: background 0.3s ease, color 0.3s ease;
    background-attachment: fixed;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ::selection {
    background: ${props => props.theme?.palette?.secondary?.main || '#03DAC6'};
    color: ${props => props.theme?.palette?.mode === 'dark' ? '#0D0221' : '#fff'};
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme?.palette?.mode === 'dark' ? '#0D0221' : '#F1F1F1'};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.palette?.mode === 'dark' ? '#4A0E78' : '#888'};
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme?.palette?.mode === 'dark' ? '#6A1B9A' : '#555'};
  }
`;